<script>
export default {
  props: ["clr"]
};
</script>

<template>
  <svg
    id="warning"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
  >
    <path id="Path_7966" data-name="Path 7966" d="M0,0H22V22H0Z" fill="none" />
    <path
      id="Path_7967"
      data-name="Path 7967"
      d="M11.979,12.808V9.38m0,6.183a.229.229,0,1,0,.23.229.228.228,0,0,0-.23-.229"
      transform="translate(-0.979 -0.782)"
      fill="none"
      :stroke="clr ? clr : '#f18f01'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_7968"
      data-name="Path 7968"
      d="M13.027,4.041l7.021,12.287a2.143,2.143,0,0,1-1.86,3.206H4.146a2.142,2.142,0,0,1-1.86-3.206L9.307,4.041a2.141,2.141,0,0,1,3.72,0Z"
      transform="translate(-0.167 -0.247)"
      fill="none"
      :stroke="clr ? clr : '#f18f01'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
